// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__IHi-w","disabled":"FileBtn_disabled__2ZzrV","warn":"FileBtn_warn__3ROXp","fade":"FileBtn_fade__3S_JI"};